"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomCodeEditor = void 0;
const react_1 = __importStar(require("react"));
const react_2 = __importDefault(require("@monaco-editor/react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const ramda_1 = require("ramda");
const helpers_1 = require("../helpers");
const useLabelTooltip_1 = require("../../useLabelTooltip");
const styled_1 = require("./styled");
function registerJsonata(monaco) {
    monaco.languages.register({ id: 'jsonata' });
    monaco.languages.setMonarchTokensProvider('jsonata', {
        tokenizer: {
            root: [
                [/\/\*.*\*\//, 'jsonata-comment'],
                [/'.*'/, 'jsonata-string'],
                [/".*"/, 'jsonata-string'],
                [/\$[a-zA-Z0-9_]*/, 'jsonata-variable'],
                [/[a-zA-Z0-9_]+/, 'jsonata-names']
            ]
        }
    });
    const brackets = [
        { open: '(', close: ')' },
        { open: '[', close: ']' },
        { open: '{', close: '}' },
        { open: '"', close: '"' },
        { open: "'", close: "'" },
        { open: '`', close: '`' }
    ];
    monaco.languages.setLanguageConfiguration('jsonata', {
        brackets: [
            ['(', ')'],
            ['[', ']'],
            ['{', '}']
        ],
        autoClosingPairs: brackets,
        surroundingPairs: brackets,
        indentationRules: {
            decreaseIndentPattern: /^((?!.*?\/\*).*\*\/)?\s*[}\])].*$/,
            increaseIndentPattern: /^((?!\/\/).)*(\{[^}"'`]*|\([^)"'`]*|\[[^\]"'`]*)$/
        }
    });
    monaco.editor.defineTheme('jsonataTheme', {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'jsonata-string', foreground: '#a00000' },
            { token: 'jsonata-comment', foreground: '#008000' },
            { token: 'jsonata-variable', foreground: '#ff4000' },
            { token: 'jsonata-names', foreground: '#0000c0' }
        ],
        colors: {
            'editor.background': '#fffffb'
        }
    });
}
const options = {
    minimap: { enabled: false },
    contextmenu: false,
    automaticLayout: true,
    scrollBeyondLastLine: false,
    extraEditorClassName: 'editor-pane'
};
const CustomCodeEditor = (field) => {
    var _a, _b, _c, _d, _e, _f;
    const hasErrors = Boolean((_a = field.rawErrors) === null || _a === void 0 ? void 0 : _a.length);
    const hint = hasErrors ? (_b = field === null || field === void 0 ? void 0 : field.rawErrors) === null || _b === void 0 ? void 0 : _b[0] : '';
    const uiOptions = (_d = (_c = field.uiSchema) === null || _c === void 0 ? void 0 : _c['ui:options']) !== null && _d !== void 0 ? _d : {};
    const language = (_e = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.language) !== null && _e !== void 0 ? _e : 'json';
    const editorOptions = (_f = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.editorOptions) !== null && _f !== void 0 ? _f : {};
    const [resizeBoxHeight, setSizeResizeBox] = (0, react_1.useState)(300);
    const label = (0, helpers_1.getLabel)(field);
    const labelTooltip = (0, useLabelTooltip_1.useLabelTooltip)(uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.labelTooltip);
    const handleEditorDidMount = (_editor, monaco) => {
        const jsonSchemas = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.jsonSchemas;
        if (language === 'json' && jsonSchemas) {
            monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
                // TODO: need to commit in RJSF https://github.com/rjsf-team/react-jsonschema-form/issues/2718
                // this validation is just recommendation, even if value didn't pass jsonSchemas it will submitted anyway
                // Why? Bc RJSF doesn't pass down any utils to set errors from Custom Inputs
                // kinda field.onSetFieldError('Well..., pun\'k, sren\'k');
                validate: true,
                schemas: jsonSchemas
            });
        }
        if (language === 'jsonata') {
            registerJsonata(monaco);
        }
    };
    const onResize = (_, { size }) => {
        setSizeResizeBox(size.height);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !(0, ramda_1.isEmpty)(label) && react_1.default.createElement(wl_ui_kit_1.FormLabel, { labelTooltip: labelTooltip }, label),
        react_1.default.createElement(styled_1.ResizeBox, { "$hasError": hasErrors, axis: "y", height: resizeBoxHeight, onResize: onResize, handle: react_1.default.createElement(styled_1.ResizeBoxHandle, null) },
            react_1.default.createElement(react_2.default, Object.assign({}, uiOptions, { language: language, loading: react_1.default.createElement(wl_ui_kit_1.Spinner, null), onChange: (value) => field.onChange(value), value: field.value, theme: language === 'jsonata' ? 'jsonataTheme' : undefined, onMount: handleEditorDidMount, options: Object.assign(Object.assign({}, options), editorOptions) }))),
        !(0, ramda_1.isEmpty)(hint) && react_1.default.createElement(wl_ui_kit_1.FormHelperText, { msgType: "error" }, hint)));
};
exports.CustomCodeEditor = CustomCodeEditor;
//# sourceMappingURL=custom-code-editor.js.map